<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9968,21.8592c-2.577,0-3.886-0.4191-5.151-0.823
      c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999c0-0.276,0.224-0.5001,0.5-0.5001
      c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759c2.423,0,3.601-0.3769,4.849-0.7759
      c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001c0,0.2769-0.223,0.4999-0.5,0.4999
      c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,21.4401,14.5758,21.8592,11.9968,21.8592 M11.9968,15.8592
      c-2.577,0-3.886-0.4191-5.151-0.823c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999
      c0-0.276,0.224-0.5001,0.5-0.5001c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759
      c2.423,0,3.601-0.3769,4.849-0.7759c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001
      c0,0.2769-0.223,0.4999-0.5,0.4999c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,15.4401,14.5758,15.8592,11.9968,15.8592
      M11.9968,18.8592c-2.577,0-3.886-0.4191-5.151-0.823c-1.247-0.4001-2.425-0.777-4.846-0.777c-0.276,0-0.5-0.223-0.5-0.4999
      c0-0.276,0.224-0.5001,0.5-0.5001c2.578,0,3.886,0.4191,5.151,0.8241c1.247,0.399,2.425,0.7759,4.846,0.7759
      c2.423,0,3.601-0.3769,4.849-0.7759c1.266-0.405,2.575-0.8241,5.154-0.8241c0.277,0,0.5,0.2241,0.5,0.5001
      c0,0.2769-0.223,0.4999-0.5,0.4999c-2.422,0-3.601,0.3769-4.849,0.777C15.8848,18.4401,14.5758,18.8592,11.9968,18.8592"/>
    <path d="M2.3633,11.267c0.4232,0.0064,0.8167,0.0233,1.1829,0.0494c0.2323-0.2743,0.5154-0.5091,0.8667-0.6503l0.6992-0.2811
      L5.0347,9.6353c-0.0234-0.226-0.0349-0.4337-0.0349-0.6351c0-3.3084,2.6917-6,6-6c2.761,0,5.1526,1.8724,5.8164,4.5533
      l0.1819,0.7352l0.7571,0.024c1.693,0.0536,3.0288,1.3314,3.2086,2.9693c0.3131-0.014,0.6459-0.0213,0.9974-0.0219
      c-0.1964-2.1701-1.969-3.8771-4.1743-3.9469c-0.7551-3.05-3.5029-5.313-6.7871-5.313c-3.866,0-7,3.133-7,7
      c0,0.25,0.0151,0.496,0.04,0.738C3.314,10.0301,2.72,10.5773,2.3633,11.267z"/>
  </g>
</template>

<script>
export default {
  name: 'Fog'
}
</script>